import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import default404_45handler_45global from "/app/terminierungsportal/middleware/default404Handler.global.ts";
import scroll_45position_45resetter_45global from "/app/base/middleware/scrollPositionResetter.global.ts";
import tracking_45global from "/app/base/middleware/tracking.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  default404_45handler_45global,
  scroll_45position_45resetter_45global,
  tracking_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "fingerprint-guard": () => import("/app/feedbackportal/middleware/fingerprintGuard.ts"),
  "technician-slug-guard": () => import("/app/feedbackportal/middleware/technicianSlugGuard.ts"),
  "visitor-id-guard": () => import("/app/feedbackportal/middleware/visitorIdGuard.ts"),
  "appointment-id-guard": () => import("/app/terminierungsportal/middleware/appointmentIdGuard.ts"),
  "appointment-loader": () => import("/app/terminierungsportal/middleware/appointmentLoader.ts"),
  "auth-guard": () => import("/app/terminierungsportal/middleware/authGuard.ts")
}